var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _rect2, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeofPingus2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 784,
    height: 424,
    viewBox: "0 0 784 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 42.0345,
    width: 784,
    height: 340.634,
    fill: "#E1B166"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3311,
    cy: 212.352,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 31.9009 204.782)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3312,
    cy: 212.352,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.262,
    cy: 217.759,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 761.831 210.189)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1793,
    cy: 174.503,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 69.7483 166.934)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1791,
    cy: 174.504,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1793,
    cy: 250.2,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 69.7483 242.63)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1791,
    cy: 250.2,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 42.0345,
    width: 784,
    height: 340.634,
    fill: "#E1B166"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3311,
    cy: 212.352,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 31.9009 204.782)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3312,
    cy: 212.352,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.262,
    cy: 217.759,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 761.831 210.189)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1793,
    cy: 174.503,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 69.7483 166.934)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1791,
    cy: 174.504,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1793,
    cy: 250.2,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 69.7483 242.63)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1791,
    cy: 250.2,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M378.279 52.5L406.314 68.5L406.225 72L378.368 56L378.279 52.5Z",
    fill: "#F0E7E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378.003 41.631L406.593 57.5L406.415 64.5L378.191 49L378.003 41.631Z",
    fill: "#F0E7E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.361 358.5L406.013 370.5C406.029 371.634 406.038 372.805 406.04 374L379.249 361.5C379.286 360.489 379.324 359.479 379.361 358.5Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M379.729 349.569L405.696 360C405.765 361.837 405.832 363.728 405.888 365.5L379.521 354.5C379.639 351.606 379.729 349.569 379.729 349.569Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.5 424C392.496 423.999 392.493 423.999 392.489 423.999C392.44 423.998 392.384 423.995 392.322 423.99L392.276 423.985C390.868 423.851 386.806 422.847 386.806 422.847C385.958 422.394 385.196 421.566 384.516 420.5H400.484C399.804 421.566 399.042 422.394 398.194 422.847C398.194 422.847 395.009 423.634 393.302 423.908C392.965 423.962 392.686 423.996 392.5 424Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.711 11C378.312 19.6988 377.962 33.7082 378.003 41.631L406.593 57.5L406.997 41.631C407.038 33.7082 406.688 19.6988 405.289 11C394.949 -0.798257 389.371 -0.926044 379.711 11ZM406.415 64.5L378.191 49L378.279 52.5L406.314 68.5L406.415 64.5ZM406.225 72L405.961 82.3599L404.753 122.578V161.432L403.89 198.412V275.098L404.926 311.226L405.271 349.569C405.271 349.569 405.491 354.548 405.696 360L379.729 349.569L380.074 311.226L381.11 275.098V198.412L380.247 161.432V122.578L379.039 82.3599L378.368 56L406.225 72ZM405.961 367.974C405.94 367.19 405.915 366.359 405.888 365.5L379.521 354.5C379.471 355.712 379.416 357.074 379.361 358.5L406.013 370.5C406 369.634 405.983 368.79 405.961 367.974ZM406.04 374C406.065 387.383 405.271 403.761 405.271 403.761C405.271 403.761 403.902 415.141 400.484 420.5H384.516C381.098 415.141 379.729 403.761 379.729 403.761C379.729 403.761 378.665 381.817 379.039 367.974C379.092 366.011 379.167 363.751 379.249 361.5L406.04 374ZM392.5 424C392.573 424.001 392.632 423.998 392.674 423.99C392.844 423.975 393.058 423.947 393.302 423.908C392.965 423.962 392.686 423.996 392.5 424ZM392.326 423.99C392.366 423.998 392.421 424 392.489 423.999C392.44 423.998 392.384 423.995 392.322 423.99L392.326 423.99Z",
    fill: "#3E3A39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M392.5 0.000741723C395.304 -0.0264689 400.116 0.684955 403.027 3.79908C403.983 4.82134 404.722 7.47454 405.289 11C394.949 -0.798257 389.371 -0.926044 379.711 11C379.919 9.7026 380.151 8.52333 380.409 7.5C380.851 5.74261 381.369 4.44514 381.973 3.79908C384.884 0.684955 389.696 -0.0264689 392.5 0.000741723Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeofPingus2);
export default __webpack_public_path__ + "static/media/EyeofPingus2.b2d8674089b7d4bfd9e814b2466afefd.svg";
export { ForwardRef as ReactComponent };